<template>


    <Authenticated>


    </Authenticated>

</template>

<script>
import Authenticated from "@/Layouts/Authenticated";
import SettingsLayout from "@/Layouts/SettingsLayout";

const tabs = [
    { name: 'My Account', href: '#', current: false },
    { name: 'Company', href: '#', current: false },
    { name: 'Team Members', href: '#', current: true },
    { name: 'Billing', href: '#', current: false },
]

export default {
    components: {Authenticated},
    layout: (h, page) => {
        return h(Authenticated, () => h(SettingsLayout, () => page))
    },
    setup() {
        return {
            tabs,
        }
    },
}
</script>
